import './App.css';
import './Config/hitelek';
import { useState, useEffect } from 'react';
import hitelek from './Config/hitelek.json';
import Table from './Table.js';

function App() {
  const [hitelTermekMegnevezes, setHitelTermekMegnevezes] = useState('');
  const [osszeg, setOsszeg] = useState(0);
  const [futamido, setFutamido] = useState(0);
  const [turelmiIdo, setTurelmiIdo] = useState(0);
  const [ugyfelTipus, setUgyfelTipus] = useState('');
  const [kamat, setKamat] = useState('');

  const [show, setShow] = useState(false);

  const [table, setTable] = useState([[], [], [], []]);
  const [osszToke, setOsszToke] = useState(0);
  const [osszKamat, setOsszKamat] = useState(0);
  const [osszesFizetendo, setOsszesFizetendo] = useState(0);

  const [osszegInfo, setOsszegInfo] = useState({ min: 0, max: 1, step: 1 });
  const [futamidoInfo, setFutamidoInfo] = useState({ min: 0, max: 1, step: 1 });
  const [turelmiIdoInfo, setTurelmiIdoInfo] = useState({
    min: 0,
    max: 1,
    step: 1,
  });
  const [ugyfelTipusInfo, setUgyfelTipusInfo] = useState([]);
  const [kamatInfo, setKamatInfo] = useState({
    honap_tol: 0,
    honap_ig: 1,
    kamatlab: 1,
  });

  const KamatSzovegFormatter = (str) => {
    if (str !== '') {
      const array = JSON.parse(str);
      let kamattomb;
      if (Array.isArray(array[0])) {
        kamattomb = array[0];
      } else {
        if (
          array !== undefined &&
          array[0] !== undefined &&
          array[0].kamat !== undefined
        ) {
          kamattomb = array[0].kamat;
        }
      }
      if (kamattomb !== undefined) {
        let newstr = '';

        for (let i = 0; i < kamattomb.length; i++) {
          if (i < kamattomb.length - 1) {
            newstr +=
              kamattomb[i].honap_tol +
              '-' +
              kamattomb[i].honap_ig +
              '. hónapig ' +
              kamattomb[i].kamatlab +
              '% - ';
          } else {
            newstr +=
              kamattomb[i].honap_tol +
              '-' +
              kamattomb[i].honap_ig +
              '. hónapig ' +
              kamattomb[i].kamatlab +
              '% ';
          }
        }
        return newstr;
      }
    } else return str;
  };

  const Calc = (osszeg, futamido, turelmiido, kamatStr) => {
    const kamatArray = JSON.parse(kamatStr);
    let onlyKamatok;
    if (Array.isArray(kamatArray[0])) {
      onlyKamatok = kamatArray[0];
    } else {
      onlyKamatok = kamatArray[0].kamat;
    }

    const ossz = parseInt(osszeg);
    const fi = parseInt(futamido);
    const ti = parseInt(turelmiido);

    let honapok = [];
    let toke = [];
    let kamat = [];
    let osszesHaviTorlesztes = [];

    for (let i = 1; i < fi + 1; i++) {
      honapok.push(i);
    }
    for (let i = 0; i < ti; i++) {
      toke.push(0);
    }
    for (let i = 0; i < fi - ti; i++) {
      toke.push(Math.round(ossz / (fi - ti)));
    }

    let kamatLabTomb = [];
    for (let i = 0; i < onlyKamatok.length; i++) {
      for (
        let j = 0;
        j < onlyKamatok[i].honap_ig - onlyKamatok[i].honap_tol + 1;
        j++
      ) {
        let aktualisKamat = onlyKamatok[i].kamatlab;
        kamatLabTomb.push(aktualisKamat);
      }
    }

    for (let i = 0; i < toke.length; i++) {
      let eddigFizetettTokeTomb = [];
      for (let y = 0; y < i + 1; y++) {
        eddigFizetettTokeTomb.push(toke[y]);
      }

      let eddigFizetettTokeOsszege = eddigFizetettTokeTomb.reduce(
        (a, b) => a + b,
        0
      );

      kamat.push(
        Math.round(((ossz - eddigFizetettTokeOsszege) * kamatLabTomb[i]) / 1200)
      );
    }

    for (let i = 0; i < honapok.length; i++) {
      osszesHaviTorlesztes.push(toke[i] + kamat[i]);
    }

    let osszKamat = kamat.reduce((a, b) => a + b, 0);
    /* let osszFizetendo = osszesHaviTorlesztes.reduce((a, b) => a + b, 0); */
    /*   alert('kamatLabTomb ' + JSON.stringify(kamatLabTomb) + kamatLabTomb.length);
    alert('Kamatok tomb ' + JSON.stringify(onlyKamatok) + onlyKamatok.length);
    alert('honapok ' + JSON.stringify(honapok) + honapok.length);
    alert('toke ' + JSON.stringify(toke) + toke.length);
    alert('kamat ' + JSON.stringify(kamat) + kamat.length);
    alert(
      'osszes havi torleszo ' +
        JSON.stringify(osszesHaviTorlesztes) +
        osszesHaviTorlesztes.length
    ); */

    if (toke.at(-1) === 0) {
      honapok.push('Végtörlesztés:');
      toke.push(ossz);
      kamat.push(0);
      osszesHaviTorlesztes.push(ossz);
    }

    setTable([honapok, toke, kamat, osszesHaviTorlesztes]);
    setOsszToke(ossz);
    setOsszKamat(osszKamat);
    setOsszesFizetendo(ossz + osszKamat);
    setShow(true);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    document.getElementById('myForm').classList.add('was-validated');
    Calc(osszeg, futamido, turelmiIdo, kamat);
  };

  useEffect(() => {
    setShow(false);
  }, [osszeg, hitelTermekMegnevezes, futamido, turelmiIdo, ugyfelTipus]);

  useEffect(() => {
    setOsszegInfo(
      hitelek.HITELEK.filter(
        (x) => x.termek.megnevezes === hitelTermekMegnevezes
      ).map((y) => y.osszeg)[0]
    );

    setFutamidoInfo(
      hitelek.HITELEK.filter(
        (x) => x.termek.megnevezes === hitelTermekMegnevezes
      ).map((y) => y.futamido)[0]
    );

    setTurelmiIdoInfo(
      hitelek.HITELEK.filter(
        (x) => x.termek.megnevezes === hitelTermekMegnevezes
      ).map((y) => y.turelmi_ido)[0]
    );

    setUgyfelTipusInfo(
      hitelek.HITELEK.filter(
        (x) => x.termek.megnevezes === hitelTermekMegnevezes
      ).map((y) => y.kamat.map((c) => c.megnevezes))[0]
    );

    setKamatInfo(
      hitelek.HITELEK.filter(
        (x) => x.termek.megnevezes === hitelTermekMegnevezes
      ).map((y) => y.kamat.map((c) => c.kamat))[0]
    );
  }, [hitelTermekMegnevezes]);

  useEffect(() => {
    if (ugyfelTipusInfo) {
      if (ugyfelTipusInfo.length === 1) {
        setKamat(JSON.stringify(kamatInfo));
      } else if (ugyfelTipusInfo.length === 0) {
        setKamat('');
      } else {
        setKamat(
          JSON.stringify(
            hitelek.HITELEK.filter(
              (x) => x.termek.megnevezes === hitelTermekMegnevezes
            )[0].kamat.filter((x) => x.megnevezes === ugyfelTipus)
          )
        );
      }
    }
    // eslint-disable-next-line
  }, [ugyfelTipusInfo, ugyfelTipus]);

  useEffect(() => {
    setTurelmiIdoInfo({ ...turelmiIdoInfo, max: futamido });
    // eslint-disable-next-line
  }, [futamido]);

  const hiteltermekek = () => {
    const hitelekNeveTomb = hitelek.HITELEK.map((x) => x.termek.megnevezes);
    return hitelekNeveTomb.map((x) => <option value={`${x}`}>{x}</option>);
  };

  const ugyfeltipusok = () => {
    return ugyfelTipusInfo.map((x) => <option value={`${x}`}>{x}</option>);
  };

  const formatNumber = (x) => {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  };

  return (
    <div className='container'>
      <div></div>
      <h1>Hitelkalkulátor</h1>
      <form onSubmit={handleSubmit} id='myForm' className='needs-validation'>
        <div className='mb-3'>
          <label className='form-label' for='hitel-tipus'>
            Hiteltermék megnevezése
          </label>
          <select
            className='form-select form-control'
            required
            id='hitel-tipus'
            onChange={(e) => {
              setHitelTermekMegnevezes(e.target.value);
            }}
            name='hitel-tipus'
          >
            <option disabled selected value=''>
              -- válasszon a lehetőségek közül --
            </option>
            {hiteltermekek()}
          </select>
          <div class='invalid-feedback'>Válasszon egy Hitel Terméket!</div>
        </div>

        <div className='mb-3'>
          {osszegInfo && osszegInfo.min ? (
            <div>
              <label className='form-label' for='osszeg'>
                Összeg (minimum: {`${formatNumber(osszegInfo.min)}`} Ft, maximum{' '}
                {`${formatNumber(osszegInfo.max)}`} Ft)
              </label>
              <input
                className='form-control'
                required
                onChange={(e) => {
                  setOsszeg(e.target.value);
                }}
                type='number'
                id='osszeg'
                name='osszeg'
                min={`${osszegInfo.min}`}
                max={`${osszegInfo.max}`}
                step={`${osszegInfo.step}`}
              />
              <div class='invalid-feedback'>
                Válasszon egy összeget {`${formatNumber(osszegInfo.min)}`} és{' '}
                {`${formatNumber(osszegInfo.max)}`} Forint között! (A legkisebb
                lépés az összegek közt {`${formatNumber(osszegInfo.step)}`}{' '}
                Forint)
              </div>
            </div>
          ) : null}
        </div>

        <div className='mb-3'>
          {futamidoInfo && futamidoInfo.min ? (
            <div>
              <label className='form-label' for='futamido'>
                Futamidő (minimum: {`${futamidoInfo.min}`} hónap, maximum{' '}
                {`${futamidoInfo.max}`} hónap)
              </label>
              <input
                className=' form-control'
                required
                onChange={(e) => {
                  setFutamido(e.target.value);
                }}
                type='number'
                id='futamido'
                name='futamido'
                min={`${futamidoInfo.min}`}
                max={`${futamidoInfo.max}`}
                step='1'
              />
              <div class='invalid-feedback'>
                Válassza meg a futamidő tartalmát {`${futamidoInfo.min}`} és{' '}
                {`${futamidoInfo.max}`} hónap között!
              </div>
            </div>
          ) : null}
        </div>

        <div className='mb-3'>
          {turelmiIdoInfo && turelmiIdoInfo.min ? (
            <div>
              <label className='form-label' for='turelmi_ido'>
                Türelmi idő (minimum: {`${turelmiIdoInfo.min}`} hónap, maximum{' '}
                {`${turelmiIdoInfo.max}`} hónap)
              </label>{' '}
              <input
                className='form-control'
                onChange={(e) => {
                  setTurelmiIdo(e.target.value);
                }}
                type='number'
                required
                id='turelmi_ido'
                name='turelmi_ido'
                min={`${turelmiIdoInfo.min}`}
                max={`${turelmiIdoInfo.max}`}
                step='1'
              />
              <div class='invalid-feedback'>
                Válassza meg a türelmi idő tartalmát {`${turelmiIdoInfo.min}`}{' '}
                és {`${turelmiIdoInfo.max}`} hónap között!
              </div>
            </div>
          ) : null}
        </div>

        {ugyfelTipusInfo && ugyfelTipusInfo.length > 1 ? (
          <div className='mb-3'>
            <label className='form-label' for='ugyfeltipus'>
              Ügyfél Típusa
            </label>
            {ugyfelTipus === '' ? (
              <select
                className='form-select form-control'
                onChange={(e) => {
                  setUgyfelTipus(e.target.value);
                }}
                name='ugyfeltipus'
                required
                id='ugyfeltipus'
              >
                <option disabled selected value=''>
                  -- válasszon a lehetőségek közül --
                </option>
                {ugyfeltipusok()}
              </select>
            ) : (
              <select
                className='form-select form-control'
                onChange={(e) => {
                  setUgyfelTipus(e.target.value);
                }}
                value={ugyfelTipus}
                name='ugyfeltipus'
                required
                id='ugyfeltipus'
              >
                <option disabled selected value=''>
                  -- válasszon a lehetőségek közül --
                </option>
                {ugyfeltipusok()}
              </select>
            )}
            <div class='invalid-feedback'>
              Válassza ki mely ügyfél típusba tartozik!
            </div>
          </div>
        ) : null}
        {kamat && kamat !== '' && kamat !== '[]' ? (
          <div className='mb-3'>
            <label className='form-label'>Kamat</label>
            <br />
            <label className='form-label'>{KamatSzovegFormatter(kamat)}</label>
            <br />
          </div>
        ) : null}

        <button type='submit' className='btn btn-outline-secondary'>
          Számol
        </button>
      </form>
      <br />
      {show ? (
        <Table
          multidimarray={table}
          osszToke={osszToke}
          osszKamat={osszKamat}
          osszesFizetendo={osszesFizetendo}
          hitelTermekMegnevezes={hitelTermekMegnevezes}
          osszeg={parseInt(osszeg)}
          futamido={parseInt(futamido)}
          turelmiIdo={parseInt(turelmiIdo)}
          kamat={KamatSzovegFormatter(kamat)}
        ></Table>
      ) : null}
      <br />
    </div>
  );
}

export default App;
